import { PermissionLevels, SharingLevels } from '../../constants/assignment-permissions'

const assignmentSelectors = {
    id: state => state.assignment.assignment?.assignment_id,
    token: state => state.assignment.assignment?.token,
    name: state => state.assignment.assignment?.assignment_name,
    type: state => state.assignment.assignment?.assignment_type,
    submissionType: state => state.assignment.assignment?.submission_type,
    language: state => state.assignment.assignment?.language,
    isFetching: state => state.assignment.isWaitingForAssignmentInfo,
    hideGrading: state => Boolean(state.assignment.assignment?.hide_grading),
    maxGrade: state => state.assignment.maxGrade,
    showGenerateSimilarSubmissionsModal: state => state.assignmentSlice.showGenerateSimilarSubmissionsModal,
    showProgressDrawer: state => state.assignmentSlice.showProgressDrawer,
    showCreateMbaModal: state => state.assignmentSlice.showCreateMbaModal,
    modelHasMba: state => state.assignment.assignment?.current_version?.has_mba,
    confirmChangesMode: state => state.assignment.confirmChangesMode,
    showQueryEditor: state => state.assignment.drawer.showQueryEditor,
    processingStatus: state => state.assignment.assignment?.current_version?.processing_status,
    processingProgress: state => state.assignment.assignment?.current_version?.processing_progress,
    processingMessage: state => state.assignment.assignment?.current_version?.processing_msg,
    accessType: state => state.assignment.assignment?.access_type,
    permissionLevel: state => state.assignment.assignment?.permission_level,
    isOwner: state => state.assignment.assignment?.permission_level === PermissionLevels.OWNER,
    isSupervisor: state => state.assignment.assignment?.sharing_level === SharingLevels.SUPERVISOR,
    isReviewer: state => state.assignment.assignment?.sharing_level === SharingLevels.REVIEWER,
    sharingLevel: state => state.assignment.assignment?.sharing_level,
    ownerId: state => state.assignment.assignment?.user_id,
    ownerName: state => state.assignment.assignment?.user_name,
    hasMbas: state => state.assignment.assignment?.has_mba,
    serverAssignmentLastModified: state => state.assignmentSlice.serverAssignmentLastModified,
    clientAssignmentLastModified: state => state.assignmentSlice.clientAssignmentLastModified,
    reviewFilter: state => state.assignment.filters.review,
    queryComparisonMode: state => state.assignment.queryComparisonMode,
    hasUnitTests: state => state.assignment.assignment?.current_version?.has_ut || false,
    trialExpired: state => state.assignment.assignment?.is_trial_valid === false,
    lmsSubmissionsImported: state => state.assignment.assignment?.lms_submissions_imported,
    lmsSubmissionsExported: state => state.assignment.assignment?.lms_grades_sent,
    lmsCourseId: state => state.assignment.assignment?.lms_course_id,
    lmsQuizId: state => state.assignment.assignment?.lms_quiz_id,
    lmsEnabled: state => state.assignment.assignment?.lms_enabled,
    startDate: state => state.assignment.assignment?.start_date,
    endDate: state => state.assignment.assignment?.end_date,
    workloadDistribution: state => state.assignment.assignment.workload_distribution,
    workloadDistributed: state =>
        state.assignment.assignment.workload_distribution &&
        state.assignment.assignment.workload_distribution.length > 0,
    description: state => state.assignment.assignment?.description,
    disciplineId: state => state.assignment.assignment?.discipline_id,
    courseId: state => state.assignment.assignment?.course_id,
    timeToSolve: state => state.assignment.assignment?.time_to_solve,
    difficultyLevel: state => state.assignment.assignment?.difficulty_level,
    prerequisites: state => state.assignment.assignment?.prerequisites || [],
    willLearn: state => state.assignment.assignment?.will_learn || [],
    sampleSubmissions: state => state.assignment.assignment?.sample_submissions || [],
    sendReasoningToStudents: state => state.assignment.assignment?.send_explainability_feedback,
    showUnitTestTips: state => state.assignment.assignment?.llm_ut_explanation,
    socraticChatEnabled: state => state.assignment.assignment?.socratic_chat_enabled,
    dispenserOn: state => state.assignment.assignment?.dispenser_on,
    feedbackPhilosophy: state => state.assignment.assignment?.philosophy_text,
    ownerShouldSeeReviewerDashboard: state => {
        const isOwner = state.assignment.assignment?.permission_level === PermissionLevels.OWNER
        const workloadDistribution = state.assignment.assignment?.workload_distribution || []
        const ownerId = state.assignment.assignment?.user_id
        
        return isOwner && workloadDistribution.some(w => w.user_id === ownerId && w.allocation > 0)
    },
}

export default assignmentSelectors
